import { render, staticRenderFns } from "./device-title.vue?vue&type=template&id=2356a014&scoped=true"
import script from "./device-title.vue?vue&type=script&lang=js"
export * from "./device-title.vue?vue&type=script&lang=js"
import style0 from "./device-title.vue?vue&type=style&index=0&id=2356a014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356a014",
  null
  
)

export default component.exports